import Settings from '@hc-frontend/shared-assets/src/js/utils/settings'

export const IS_LOCAL_ENVIRONMENT = /development|test/i.test(process.env.NODE_ENV)
export const IS_PROD = Settings.isProd

export type Environment = 'prod' | 'stg' | 'qa'

let env: Environment
if (Settings.isProd) env = 'prod'
else if (Settings.isQa || IS_LOCAL_ENVIRONMENT) env = 'qa'
else env = 'stg'

export const ENV: Environment = env

export const PRODUCT = String(process.env.PRODUCT).toLowerCase()
export const PRODUCT_ENROLL = 'enroll'
export const PRODUCT_FI = 'fixed-benefit-medical'
export const PRODUCT_STM = 'short-term-health-insurance'
export const PRODUCT_BTM = 'bridge-to-medicare'
export const PRODUCT_DENTAL_AND_VISION = 'dental-and-vision'
export const MEDICARE_SUPPLEMENT = 'medicare-supplement'

export const IS_AGENT = process.env.FLOW === 'agent'

export const IS_FIXED_BENEFIT_MEDICAL = PRODUCT === PRODUCT_FI

export const IS_SHORT_TERM = PRODUCT === PRODUCT_STM

export const IS_BRIDGE_TO_MEDICARE = PRODUCT === PRODUCT_BTM

export const IS_ENROLL = PRODUCT === PRODUCT_ENROLL

export const IS_DENTAL_AND_VISION = PRODUCT === PRODUCT_DENTAL_AND_VISION

export const IS_MEDICARE_SUPPLEMENT = PRODUCT === MEDICARE_SUPPLEMENT

export const IS_GENERIC_LANDING = process.env.DOMAIN === 'pivot.landings'

export const GTM_ID = IS_ENROLL ? 'GTM-WFF68ZL' : 'GTM-TSVGZR3' // cspell:disable-line

export const FLOW = IS_ENROLL ? 'enroll' : IS_AGENT ? 'agent' : 'consumer'

export const SALES_CENTER_AGENCY = '58568'

export const HC_AGENCY_ID = '150011'

export const CONSUMER_ORGANIC_AGENT_ID = 2010000

export const DTC_LOCAL_PORT = 3100

export const SHOW_UH_ONE_BANNER_ENROLL_QUOTES = true

/* Amplitude key configuarions for each environment and application */
const amplitudeDeploymentKeys = {
  enroll: {
    /* DEVELOPMENT: pivot-health-legacy-dtc */
    qa: 'client-YaJddG1K72rzPmsMxQ2LfjBef9JPgkd7',
    /* DEVELOPMENT: pivot-health-legacy-dtc-stg */
    stg: 'client-PLXxU7TriL4HBC3DSDBjuaAYmezspo7B',
    /* PRODUCTION: pivot-health-legacy-dtc */
    prod: 'client-geZsxQBUqFWWjp2vy4H56hZPAGzXOce4'
  },
  agent: {
    /* DEVELOPMENT: pivot-health-legacy-agents */
    qa: 'client-yjESpxjKAqn8f9FQOLckmGidIlAgBd71',
    /* DEVELOPMENT: pivot-health-legacy-agents-stg */
    stg: 'client-Dt3FRZ4ecNz0wu52wb0aOtl96V3I6N32',
    /* PRODUCTION: pivot-health-legacy-agents */
    prod: 'client-6Jck3AafGvzgG85aaukxz7J6cmDK1xkB'
  }
}

function getAmplitudeDeploymentKey(): string {
  return IS_AGENT
    ? amplitudeDeploymentKeys.agent[ENV]
    : amplitudeDeploymentKeys.enroll[ENV]
}

/** API key used for Amplitude experiment. Specific to site and environment so that it can be used for targeting. */
export const AMPLITUDE_DEPLOYMENT_KEY = getAmplitudeDeploymentKey()

/** Default sort order for DTC quotes, used as the value of the `sort` URL parameter */
export const DTC_DEFAULT_SORT = 'deductible'

/** Brochure link for multi-carrier plans */
export const MULTI_CARRIER_BROCHURE_LINK =
  'https://cdn.pivothealth.com/resources/brochures/PH1-3-12_062024.pdf'

/** Default plan ID to show when skipping the quotes page */
const MULTI_CARRIER_DEFAULT_PLAN_QA = 612
const MULTI_CARRIER_DEFAULT_PLAN_PRODUCTION = 552

function getDefaultPlanId(): number {
  if (ENV === 'prod') return MULTI_CARRIER_DEFAULT_PLAN_PRODUCTION
  else return MULTI_CARRIER_DEFAULT_PLAN_QA
}

export const MULTI_CARRIER_DEFAULT_PLAN = getDefaultPlanId()
